module.exports = __webpack_public_path__ + "static/media/amex-logo.0e5a8173.svg";